import { useEffect, useState } from "react";

// État replié de la barre latérale : mémorisé, partagé entre la barre et le contenu.
const CLE = "komptai.sidebar.collapsed";
const EVT = "komptai:sidebar-collapsed";

export const isSidebarCollapsed = () => {
  try { return localStorage.getItem(CLE) === "1"; } catch { return false; }
};

export const setSidebarCollapsed = (v) => {
  try { localStorage.setItem(CLE, v ? "1" : "0"); } catch { /* stockage indisponible */ }
  window.dispatchEvent(new Event(EVT));
};

export function useSidebarCollapsed() {
  const [collapsed, setLocal] = useState(isSidebarCollapsed);
  useEffect(() => {
    const maj = () => setLocal(isSidebarCollapsed());
    window.addEventListener(EVT, maj);
    window.addEventListener("storage", maj);
    return () => { window.removeEventListener(EVT, maj); window.removeEventListener("storage", maj); };
  }, []);
  return [collapsed, setSidebarCollapsed];
}

// Repli automatique au seul FRANCHISSEMENT du seuil : un redimensionnement qui reste
// du même côté ne touche à rien, donc un dépliage manuel tient jusqu'au prochain
// franchissement. Rien n'est forcé au chargement : l'état mémorisé prime.
export function useSidebarAutoCollapse(seuil = 1280) {
  useEffect(() => {
    let etroit = window.innerWidth < seuil;
    const onResize = () => {
      const maintenant = window.innerWidth < seuil;
      if (maintenant === etroit) return;
      etroit = maintenant;
      setSidebarCollapsed(maintenant);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [seuil]);
}
